angular.module("Main").factory("UserDecoratingInterceptor", ["NODEBACKEND", "SessionCache", function (NODEBACKEND, SessionCache) {
    return {
        request: request
    };

    function request(req) {
        if (_.startsWith(req.url, NODEBACKEND)) {
            req.headers.ClubId = SessionCache.get().cid;
            req.headers.sid = "65d82d4e-d231-4c09-8e71-959256deae44";
            // if (!req.headers.SessionId)
            //     req.headers.SessionId = SessionCache.get().sid;
            const sessionCache = SessionCache.get()
            if(sessionCache.globals && sessionCache.globals.currentUser && sessionCache.globals.currentUser.token)
                req.headers.Authorization = `Bearer ${sessionCache.globals.currentUser.token}`
        }

        return req;
    }
}]);

